
/* The Palette Library: Search, live inventory, and Add to Cart */

(function () {
  "use strict";

  function initializePaletteLibrary() {
    const root = document.getElementById("bpa-build");
    if (!root || root.dataset.paletteScriptInitialized === "true") return;

    root.dataset.paletteScriptInitialized = "true";

    const base =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

    const rootPath = base.endsWith("/") ? base : base + "/";
    const cards = Array.from(root.querySelectorAll(".bpa-grid article"));
    const search = root.querySelector("#bpa-palette-search");
    const searchStatus = root.querySelector("#bpa-search-status");

    const productCache = new Map();
    const pending = new Map();

    function searchPalettes() {
      if (!search) return;

      const term = search.value.trim().toLocaleLowerCase();
      let shown = 0;

      for (const card of cards) {
        const matches =
          !term || card.textContent.toLocaleLowerCase().includes(term);

        card.style.display = matches ? "" : "none";
        if (matches) shown++;
      }

      if (searchStatus) {
        searchStatus.textContent = term
          ? shown + (shown === 1 ? " palette" : " palettes") + " found"
          : "";
      }
    }

    if (search) {
      search.addEventListener("input", searchPalettes);
    }

    function getProduct(handle, force) {
      if (!force && productCache.has(handle)) {
        return Promise.resolve(productCache.get(handle));
      }

      if (pending.has(handle)) {
        return pending.get(handle);
      }

      const promise = fetch(
        rootPath + "products/" + encodeURIComponent(handle) + ".js",
        {
          credentials: "same-origin",
          cache: "no-store"
        }
      )
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Product no longer available");
          }
          return response.json();
        })
        .then(function (product) {
          productCache.set(handle, product);
          return product;
        })
        .catch(function () {
          productCache.delete(handle);
          return null;
        })
        .finally(function () {
          pending.delete(handle);
        });

      pending.set(handle, promise);
      return promise;
    }

    function availableIds(row) {
      const product = productCache.get(row.dataset.bpaHandle);

      if (!product || !Array.isArray(product.variants)) {
        return { half: null, full: null };
      }

      const available = product.variants.filter(function (variant) {
        return variant.available === true;
      });

      // Metallic and shimmer paints only come in half pans.
      if (row.dataset.bpaMetallic === "1") {
        const onlyPan = available.find(function (variant) {
          return variant.title === "Default Title";
        });

        return {
          half: onlyPan ? String(onlyPan.id) : null,
          full: null
        };
      }

      const half = available.find(function (variant) {
        return /half\s*pan/i.test(variant.title);
      });

      const full = available.find(function (variant) {
        return /full\s*pan/i.test(variant.title);
      });

      return {
        half: half ? String(half.id) : null,
        full: full ? String(full.id) : null
      };
    }

    function updateCard(card) {
      const half = [];
      const full = [];

      card.querySelectorAll(".bpa-colour").forEach(function (row) {
        const label = row.querySelector(".bpa-availability");
        if (!label) return;

        const ids = row.dataset.bpaHandle
          ? availableIds(row)
          : { half: null, full: null };

        if (ids.half) half.push(ids.half);
        if (ids.full) full.push(ids.full);

        if (row.dataset.bpaMetallic === "1") {
          label.textContent = ids.half
            ? "(Half pan only)"
            : "(Sold out)";
        } else {
          label.textContent =
            ids.half && ids.full
              ? "(H/F)"
              : ids.half
                ? "(H/Sold out)"
                : ids.full
                  ? "(Sold out/F)"
                  : "(Sold out)";
        }
      });

      card.querySelectorAll("button[data-bpa-size]").forEach(function (button) {
        const size = button.dataset.bpaSize;
        const ids = size === "half" ? half : full;

        button.dataset.ids = ids.join(",");
        button.disabled = ids.length === 0;
        button.textContent =
          "Add " + size + " pans (" + ids.length + ")";
      });
    }

    async function checkHandles(handles, force) {
      const unique = Array.from(new Set(handles.filter(Boolean)));
      let index = 0;

      async function worker() {
        while (index < unique.length) {
          const handle = unique[index++];
          await getProduct(handle, force);
        }
      }

      await Promise.all(
        Array.from(
          { length: Math.min(8, unique.length) },
          worker
        )
      );
    }

    function handlesFor(card) {
      return Array.from(
        card.querySelectorAll(".bpa-colour[data-bpa-handle]"),
        function (element) {
          return element.dataset.bpaHandle;
        }
      );
    }

    // Prepare the buttons for live inventory updates.
    cards.forEach(function (card) {
      card.querySelectorAll("button[data-ids]").forEach(function (button) {
        if (/Add half pans/i.test(button.textContent)) {
          button.dataset.bpaSize = "half";
        }

        if (/Add full pans/i.test(button.textContent)) {
          button.dataset.bpaSize = "full";
        }

        button.disabled = true;
      });
    });

    function updateCartIcon(cart) {
      document.querySelectorAll(".cart__toggle").forEach(function (icon) {
        icon.classList.toggle(
          "cart__toggle--has-items",
          (cart.item_count || 0) > 0
        );
      });
    }

    async function refreshThemeCart() {
      const response = await fetch(rootPath + "cart.js", {
        credentials: "same-origin",
        cache: "no-store"
      });

      if (response.ok) {
        updateCartIcon(await response.json());
      }

      const nativeCart = window.cart;

      if (!nativeCart || typeof nativeCart.build !== "function") {
        return;
      }

      const section = await fetch(
        rootPath + "cart?section_id=api-cart-items",
        {
          credentials: "same-origin",
          cache: "no-store"
        }
      );

      if (!section.ok) return;

      const wrapper = document.createElement("div");
      wrapper.innerHTML = await section.text();

      const content = wrapper.querySelector("[data-api-content]");

      if (content) {
        nativeCart.build(content);
      }
    }

    // Add available individual colours to the existing cart.
    root.addEventListener("click", async function (event) {
      const button = event.target.closest("button[data-bpa-size]");

      if (!button || !root.contains(button) || button.disabled) {
        return;
      }

      const card = button.closest("article");
      const status = card.querySelector(".status");

      button.disabled = true;

      if (status) {
        status.textContent = "Checking available colours…";
      }

      try {
        // Check stock again immediately before adding.
        await checkHandles(handlesFor(card), true);
        updateCard(card);

        const ids = (button.dataset.ids || "")
          .split(",")
          .filter(Boolean);

        if (!ids.length) {
          if (status) {
            status.textContent =
              "All colours in this size are sold out.";
          }
          return;
        }

        button.disabled = true;

        if (status) {
          status.textContent = "Adding colours…";
        }

        const response = await fetch(rootPath + "cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            items: ids.map(function (id) {
              return {
                id: Number(id),
                quantity: 1
              };
            })
          })
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            result.message ||
            "Could not add colours"
          );
        }

        if (status) {
          status.textContent = "Added " + ids.length + " colours";
        }

        try {
          await refreshThemeCart();
        } catch (error) {
          // Products were added even if the drawer refresh fails.
        }
      } catch (error) {
        if (status) {
          status.textContent =
            error.message ||
            "Unable to add colours. Please try again.";
        }
      } finally {
        updateCard(card);
      }
    });

    // Fetch current stock when the page opens.
    checkHandles(cards.flatMap(handlesFor), false).then(function () {
      cards.forEach(updateCard);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializePaletteLibrary,
      { once: true }
    );
  } else {
    initializePaletteLibrary();
  }
})();
